import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import { AccordionSummary, AccordionDetails } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      // fontWeight: theme.typography.fontWeightRegular,
      // color: 'rgb(0, 160, 175)',
      // fontWeight: 'bold',
      // fontSize: '0.85rem'
    },
  }));

const SimpleExpansionPanel = props => {
    const { name, children, expanded, handleChange} = props
    const classes = useStyles();
    return (
        <div className={classes.root}>
          <br/>
            <Accordion  expanded={expanded} onChange={handleChange}>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                <Typography className={classes.heading}>{name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    { children }
                </AccordionDetails>
            </Accordion>
    </div>
    );
};

SimpleExpansionPanel.propTypes = {
    name: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default SimpleExpansionPanel;